var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{staticClass:"mid-indicator"},[_c('path',{style:(_vm.midIndicatorStyle),attrs:{"d":_vm.midIndicatorPath}}),_c('path',{staticStyle:{"fill":"none"},attrs:{"d":_vm.midIndicatorPathOffset,"stroke":"white","stroke-width":(!_vm.isPigtail ? _vm.whiteIndicatorOffset : _vm.whiteIndicatorPigtailBleeding)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }